<template>
    <div class="row">
        <div class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">Exit Interview form</div>
                    </div>
                    <div class="form mt-3">
                        <div class="row mb-3">
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">1.	What are your primary reasons for leaving?</label>
                                    <textarea
                                        v-model="form.primary_reason_leaving"
                                        type="text"
                                        class="form-control"
                                        :readonly="isFilled"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">2.	Was there a specific event of issue that made you want to resign? If yes, please explain</label>
                                    <textarea
                                        v-model="form.specific_event_of_issue"
                                        type="text"
                                        class="form-control"
                                        :readonly="isFilled"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">3.	If yes, did you discuss this matter with your supervisor/manager?</label>
                                    <textarea
                                        v-model="form.did_discuss"
                                        type="text"
                                        class="form-control"
                                        :readonly="isFilled"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">4.	Were there any company policies or procedures that made your work at ORNA more difficult?</label>
                                    <textarea
                                        v-model="form.were_policies_or_procedures"
                                        type="text"
                                        class="form-control"
                                        :readonly="isFilled"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">5.	Where will you be working now and how did you come to choose working there?</label>
                                    <textarea
                                        v-model="form.where_will_you_be_working_now"
                                        type="text"
                                        class="form-control"
                                        :readonly="isFilled"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">6.	When do you begin working at your new job?</label>
                                    <textarea
                                        v-model="form.when_begin_working_at_new_job"
                                        type="text"
                                        class="form-control"
                                        :readonly="isFilled"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">7.	What positive experiences did you have with the company?</label>
                                    <textarea
                                        v-model="form.positive_experiences"
                                        type="text"
                                        class="form-control"
                                        :readonly="isFilled"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">8.	What do you think could be improved about the job?</label>
                                    <textarea
                                        v-model="form.what_could_be_improved"
                                        type="text"
                                        class="form-control"
                                        :readonly="isFilled"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">9.	Would you consider returning to this company in the future?</label>
                                    <textarea
                                        v-model="form.consider_returning"
                                        type="text"
                                        class="form-control"
                                        :readonly="isFilled"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">10.	Would you recommend this company to a friend as a good place to work?</label>
                                    <textarea
                                        v-model="form.would_recommend_company"
                                        type="text"
                                        class="form-control"
                                        :readonly="isFilled"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="!isDemonstration">
                            <div class="col-12">
                                <div class="btns-wrap">
                                    <button
                                        @click="showModal"
                                        class="btn btn--outline-primary w-100 w-sm-auto"
                                    >Cancel</button>
                                    <ActionModal confirm-text="Yes" reject-text="No"
                                                 :modalId="`exit-interview`"
                                                 @confirm="closeWindow">
                                        <template #body>
                                            <div class="text-center mb-4">
                                                <h4>
                                                    Are you sure you want <br> to close  this item? <br>
                                                    Your answers will not be saved.
                                                </h4>
                                            </div>
                                        </template>
                                    </ActionModal>
                                    <button
                                        class="btn btn--secondary w-100 w-sm-auto "
                                        data-dismiss="modal" data-toggle="modal" data-target="#submit"
                                        @click="sendForm"
                                    >Save</button>

                                    <div class="modal modal-delete fade" id="submit" tabindex="-1" role="dialog" aria-labelledby="submit" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered" role="document">
                                            <div class="modal-content">
                                                <div class="modal-header">

                                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                    </button>
                                                </div>
                                                <div class="modal-body">
                                                    <div class="modal-inner">
                                                        <div class="text-center">
                                                            <h4>Thank you</h4>
                                                            <p>Thank you, your exit interview form has been submitted. Please feel free to call the ORNA office if you require further assistance.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import DeactivationServices from "../../../../Applicants/resources/js/services/DeactivationServices";
import ActionModal from "../../../../../../resources/js/components/ActionModal.vue";

export default {
    components: {ActionModal},
    props: {
        applicantsAnswers: {
            type: Object,
            required: false
        },
        isFilled: {
            type: Boolean
        }
    },
    name: 'ExitInterviewForm',
    data() {
        return {
            isDemonstration: false,
            form: {
                primary_reason_leaving: null,
                specific_event_of_issue: null,
                did_discuss: null,
                were_policies_or_procedures: null,
                where_will_you_be_working_now: null,
                when_begin_working_at_new_job: null,
                positive_experiences: null,
                what_could_be_improved: null,
                consider_returning: null,
                would_recommend_company: null,
                applicant_id: null,
                status_history_id: null,
            }
        }
    },
    methods: {
        checkFilledInfo() {
            if (Boolean(this.isFilled)) {
                this.isDemonstration = true
                this.setData(this.applicantsAnswers)
            } else {
                this.isDemonstration = false
            }
        },
        closeWindow() {
            window.close()
        },
        async sendForm() {
            try {
                await DeactivationServices.sendInterviewForm(this.form);
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Your answers was not submitted, please try again')
            }
        },
        async getIds() {
            const url = window.location.href;
            const match = url.match(/\/applicants\/(\d+)\/status-history\/(\d+)\/exit-interview\/show/);

            if (match) {
                this.form.applicant_id = match[1];
                this.form.status_history_id = match[2];

            } else {
                console.log("URL does not match the expected pattern.");
            }
        },
        setData(answers) {
            for (const userKey of Object.keys(answers)) {
                if (this.form.hasOwnProperty(userKey)) {
                    this.form[userKey] = answers[userKey];
                }
            }
        },
        showModal() {
            $(`#exit-interview`).modal()
        }
    },
    mounted() {
        if (Boolean(!this.isFilled)) {
            this.getIds()
        }
        this.checkFilledInfo()

    }

}

</script>


<style scoped>

</style>
